import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Divider, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import MarketOrderBuyForm from "../buyTypesForm/MarketOrderBuyForm";
import LimitOrderBuyForm from "../buyTypesForm/LimitOrderBuyForm";
import StopLimitOrderBuyForm from "../buyTypesForm/StopLimitOrderBuyForm";

const BuyOrderTypeTab = React.memo((props) => {
	const { coinPrice, coinSymbol } = props;
	console.log(coinPrice);
	const [value, setValue] = React.useState("1");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%", typography: "body1" }}>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList onChange={handleChange} aria-label="lab API tabs example">
						<Tab label="Market Order" value="1" />
						{/* <Tab label="Buy Limit" value="2" /> */}
						{/* <Tab label="BUY Stop " value="3" /> */}
						{/* <Tab label="Recent investmet" value="4" /> */}
					</TabList>
				</Box>
				<TabPanel value="1">
					<MarketOrderBuyForm coinPrice={coinPrice} coinSymbol={coinSymbol} />
				</TabPanel>
				{/* <TabPanel value="2">
					<LimitOrderBuyForm coinPrice={coinPrice} coinSymbol={coinSymbol} />
				</TabPanel>
				<TabPanel value="3">
					<StopLimitOrderBuyForm
						coinPrice={coinPrice}
						coinSymbol={coinSymbol}
					/>
				</TabPanel> */}
			</TabContext>
		</Box>
	);
});

export default BuyOrderTypeTab;
